import "./polyfills";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import posthog from "posthog-js";
import { Capacitor } from "@capacitor/core";
import { APP_VERSION } from "./changelog";

// Set sidebar width CSS variable before first render to avoid layout flash
document.documentElement.style.setProperty(
  "--hw-sidebar-w",
  localStorage.getItem("hw-sidebar-collapsed") === "true" ? "56px" : "220px"
);

if (process.env.REACT_APP_POSTHOG_KEY) {
  const apiHost = Capacitor.isNativePlatform()
    ? "https://us.i.posthog.com"
    : process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: apiHost,
    ui_host: "https://us.posthog.com",
    persistence: "localStorage",
    capture_pageview: false,
    capture_pageleave: true,
    ip: false,
    disable_session_recording: true,
  });
  posthog.register({
    platform: Capacitor.getPlatform(),
    app_version: process.env.REACT_APP_VERSION || APP_VERSION,
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

